export function getTitleForExperienceType(type: string) {
  switch (type) {
    case 'spa-treatments':
      return 'app.spaTreatments';
    case 'spa-facilities':
      return 'app.spaFacilities';
    case 'spa-classes':
      return 'app.spaClasses';
    default:
      return 'app.spaTreatments';
  }
}
